import { render, staticRenderFns } from "./CategoryManage.vue?vue&type=template&id=1af76153&scoped=true"
import script from "./CategoryManage.vue?vue&type=script&lang=js"
export * from "./CategoryManage.vue?vue&type=script&lang=js"
import style0 from "./CategoryManage.vue?vue&type=style&index=0&id=1af76153&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af76153",
  null
  
)

export default component.exports